import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Partner from '../../components/partner'
import FooterLightSmall from '../../components/footer-light-small'
import FreelancerFaq from '../../components/freelancer-faq'

import bg1 from '../../assets/images/freelancer/bg.jpg'
import heroImg from '../../assets/images/freelancer/hero.png'
import experienceImg from '../../assets/images/freelancer/experience.png'

import { portfolioData, servicesData, skillData,portfolioImages } from '../../data/freelancer'

import {FiX} from '../../assets/icons/vander'

import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css'; 

export default function IndexFreelancer() {
  let [isOpen, setisOpen] = useState(false);
  let [currentImageIndex, setCurrentImageIndex] = useState(0);
  let [show, setShow] = useState(false)

  let handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setisOpen(true);
};
let handleMovePrev = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + portfolioImages.length - 1) % portfolioImages.length);
};

let handleMoveNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % portfolioImages.length);
};
let currentImage = portfolioImages[currentImageIndex];

  return (
    <>
     <Navbar/> 

    <section className="bg-hero pb-0 d-table w-100" style={{backgroundImage:`url(${bg1})`}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-7 col-md-7">
                  <div className="title-heading">
                      <h4 className="mb-2 text-muted">I'm Graphics Designer</h4>
                      <h1 className="display-2 fw-bold mb-3">Krista Lopez</h1>
                      <p className="para-desc text-muted">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2">
                          <Link to="#" className="btn btn-primary mouse-down mt-2 me-2">View Portfolio</Link>
                          <Link to="#" className="btn btn-outline-primary mouse-down mt-2">Contact Me</Link>
                      </div>
                  </div>
              </div>

              <div className="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <img src={heroImg} className="img-fluid" alt=""/>
              </div>
          </div>
      </div> 
      <div className="home-shape-arrow">
          <Link to="#" className="mouse-down"><i className="mdi mdi-arrow-down arrow-icon text-dark h5"></i></Link>
      </div> 
    </section>

    <section className="section" id="skills">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">My Skills</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
                {skillData.map((item,index)=>{
                  return(
                  <div className="col-md-6 pt-2" key={index}>
                    <div className="progress-box mt-4">
                        <h6 className="title text-muted">{item.title}</h6>
                        <div className="progress">
                            <div className={`progress-bar progress-bar-striped position-relative ${item.bg}`} style={{width:item.value}}>
                                <div className="progress-value d-block text-muted h6">{item.value}</div>
                            </div>
                        </div>
                    </div>
                  </div>
                  )
                })}
          </div>
      </div>
      <div className="home-shape-arrow">
          <Link to="#" className="mouse-down"><i className="mdi mdi-arrow-down arrow-icon bg-white text-dark h5"></i></Link>
      </div> 
    </section>

    <section className="section bg-light" id="services">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">What I Offer ?</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {servicesData.map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-4 rounded">
                          <i className={`text-primary mdi-36px ${item.icon}`}></i>
                          <div className="content mt-2">
                              <h4 className="title">{item.title}</h4>
                              <p className="text-muted mt-2">{item.desc}</p>
                              <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right"></i></Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
      <div className="home-shape-arrow">
          <Link to="#" className="mouse-down"><i className="mdi mdi-arrow-down arrow-icon text-dark h5"></i></Link>
      </div> 
    </section>

    <section className="section" id="experience">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">My Experience</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6 mt-4 pt-2">
                  <img src={experienceImg} className="img-fluid" alt=""/>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 pt-2">
                  <FreelancerFaq/>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-12">
                  <Partner/>
              </div>
          </div>
      </div>
      <div className="home-shape-arrow">
          <Link to="#" className="mouse-down"><i className="mdi mdi-arrow-down arrow-icon bg-light text-dark h5"></i></Link>
      </div> 
    </section>

    <section className="section bg-light" id="portfolio">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">My Work & Portfolio</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
      </div>

      <div className="container">
          <div className="row container-grid projects-wrapper">
            {portfolioData.map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                      <div className="work-container position-relative d-block overflow-hidden rounded">
                          <Link to="#" onClick={() => handleImageClick(index)} className="lightbox d-inline-block" title="">
                              <img src={item.image} className="img-fluid" alt=""/>
                          </Link>
                          <div className="content bg-white p-3">
                              <Link to="/portfolio-detail-one" className="title d-block fw-bold text-dark">{item.name}</Link>
                              <small className="text-muted">{item.title}</small>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60" id="contactme">
          <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4 className="text-white title-dark">Ready to start your project ?</h4>
                          <p className="text-white-50 para-desc para-dark mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="#" className="btn btn-outline-primary" onClick={()=>setShow(!show)}><i className="mdi mdi-phone-outline"></i> Contact Now</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className={`modal fade ${show ? 'show d-block' : ''}`} style={{backgroundColor:'#00000099'}}>
          <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content rounded shadow border-0">
                  <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalCenterTitle">Get In Touch ! </h5>
                      <button type="button" className="btn btn-icon btn-close" onClick={()=>setShow(!show)}><FiX className="fs-4 text-dark"/></button>
                  </div>
                  <div className="modal-body">
                      <div className="custom-form">
                          <form>
                              <div className="row">
                                  <div className="col-12">
                                      <div className="mb-3">
                                          <label className="form-label">Your Name <span className="text-danger">*</span></label>
                                          <input name="name" id="name" type="text" className="form-control" placeholder="Name :"/>
                                      </div>
                                  </div>

                                  <div className="col-12">
                                      <div className="mb-3">
                                          <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                          <input name="email" id="email" type="email" className="form-control" placeholder="Email :"/>
                                      </div> 
                                  </div>

                                  <div className="col-12">
                                      <div className="mb-3">
                                          <label className="form-label">Subject</label>
                                          <input name="subject" id="subject" className="form-control" placeholder="subject :"/>
                                      </div>
                                  </div>

                                  <div className="col-12">
                                      <div className="mb-3">
                                          <label className="form-label">Comments <span className="text-danger">*</span></label>
                                          <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Message :"></textarea>
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  <div className="col-12">
                                      <div className="d-grid">
                                          <button type="submit" id="submit" name="send" className="btn btn-primary">Send Message</button>
                                      </div>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
      {isOpen && (
        <Lightbox
            mainSrc={currentImage}
            prevSrc={portfolioImages[(currentImageIndex + portfolioImages.length - 1) % portfolioImages.length]}
            nextSrc={portfolioImages[(currentImageIndex + 1) % portfolioImages.length]}

            onCloseRequest={() => setisOpen(false)}
            onMovePrevRequest={handleMovePrev}
            onMoveNextRequest={handleMoveNext}
        />
    )}
    <FooterLightSmall/>
    </>
  )
}
